<template>
    <div>
        <button @click="openUploadPopup" id="add-new-document">+</button>
        <b-modal
            hide-footer
            centered
            ref="add-document-modal"
            id="add-document-modal"
            title="Adicionar novo documento"
        >
        <template #modal-title>
            <div class="header-title">ADICIONAR NOVO DOCUMENTO</div>
        </template>
        <div>
            <input type="file" v-on:change="GetValueFile" id="impor-pdf" itemid="impor-pdf">
            <div class="embaixo">
              <div class="d-flex justify-content-center">
                <div>
                  <div v-if="this.nameInput == '' " v-on:click="openFilePdf" class="Icon">
                    <i class="fas fa-file-image"></i>
                  </div>
                  <div v-if="this.nameInput != ''" v-on:click="openFilePdf" class="Icon">
                    <i class="fas fa-file-pdf"></i>
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-center mt-2">
                  <label>{{ nameInput }}</label>
                </div>
              </div>
            </div>
        </div>
            <b-form v-on:submit.prevent="()=>{}">
                    <div class="container-income-form">

                    <b-form-group
                    id="input-group-uf-creci"
                    label="Destino do arquivo:"
                    label-for="input-uf-creci"
                    >
                        <div
                        >
                            <b-form-select v-model="opDestiny" class="mb-3 margin-">
                            <template #first>
                                <b-form-select-option :value="null" disabled>Selecione</b-form-select-option>
                            </template>
                            <b-form-select-option selected value=1>Empreendimento</b-form-select-option>
                            <b-form-select-option  value=2>Cliente</b-form-select-option>
                            </b-form-select>

                        </div>
                    </b-form-group>

                        <div class="section-destinations">
                            <div class="enterprise-select" v-show="opDestiny == 1">
                                <div class="label">
                                    Selecione um empreendimento:
                                </div>
                                <select v-model="enterpriseSelected" class="select-empreendimento">
                                    <option v-for="enterprise in enterprises" :key="enterprise.id" :value="enterprise.id">{{enterprise.nome}}</option>
                                </select>
                            </div>

                            <div class="enterprise-select" v-show="opDestiny == 2">
                                <b-form-group id="input-cpf" label="Digite o CPF do cliente:">
                                    <b-form-input
                                    id="customer-cpf-input"
                                    name="customer-cpf-input"
                                    @input="searchCustomer"
                                    v-model="customerCpf"
                                    v-validate="{ required: true, length: 14, numeric: false }"
                                    type="text"
                                    placeholder="___.___.___-__"
                                    required
                                    v-mask="['###.###.###-##']"
                                    ></b-form-input>
                                </b-form-group>
                                <div class="container-selected-customer">
                                    <div class="select-customer"><div v-show="customerSelected.find">Nome do cliente: </div>{{customerSelected.nome}}</div>
                                </div>
                            </div>
                        </div>

                      <div class="container-buttons-form">
                        <button @click="closeUploadPopup" class="button-cancel">
                          Cancelar
                        </button>
                        <button @click="uploadNewDocument" class="button-save">Adicionar</button>
                      </div>
                    </div>
                  </b-form>
        </b-modal>
    </div>
</template>

<script>
import AddDocumentButton from './AddDocumentButton.js'
export default AddDocumentButton
</script>

<style>
.header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}

.embaixo {
  display: flex;
  flex-direction: column;
}
.Icon {
  align-items: center;
  display: flex;
  width: 170px;
  height: 150px;
  color: rgb(147, 137, 139);
  background-color: #dedede;
  font-size: 50px;
  justify-content: center;
  border-style: dotted;
  cursor: pointer;
  border-radius: 10px 10px 10px 10px;

}

#impor-pdf {
  display: none;
}
#add-new-document{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}
#container-destiny-select{
  display: flex;
  flex-direction: column;
}

.section-destinations{
    min-height: 100px;
}

.container-buttons-form{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.button-save{
  background-color: #008148;
  color: white;

}

.select-customer{
    display: flex;
    gap: 2px;
}

.select-empreendimento{
    width: 100%;
    border-color: #c0bcbc;
    height: 2rem;
}

</style>



// WEBPACK FOOTER //
// src/views/private/documentsManagement/components/AddDocumentButton/AddDocumentButton.vue